import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
 import { PhotoAlbumService } from 'src/app/shared/API-Service/services/photo-album.service';
import { PhotoService } from 'src/app/shared/API-Service/services/photo.service';


@Component({
  selector: 'app-insert-photo',
  templateUrl: './insert-photo.component.html',
  styleUrls: ['./insert-photo.component.css']
})
export class InsertPhotoComponent implements OnInit {
  recordtoupdate: any;
  photoalbum:any;
  photoForm:FormGroup;
  photoFormdata:FormData;
  update:boolean = false;
  button:boolean = false;
  Image: File;
imageLogo: string;
img : string = Image;
  constructor(private _PhotoService:PhotoService,private _Router:Router,private _FormBuilder:FormBuilder,private _PhotoAlbumService:PhotoAlbumService) {
    this.imageLogo="../../../../../assets/images/upload.png"

   }

  ngOnInit(): void {
    this.initiate();
    this.getphotoalbum();
    this.checkEdit();
  }
  initiate(){
    this.photoForm = this._FormBuilder.group({
      title: [''],
      titleAr: ['', Validators.required],
     photoalbumid:['', Validators.required],
     photoimage:['', Validators.required],
    
    });
  }

  getphotoalbum(){
    this._PhotoAlbumService.GetPhotoAlbum().subscribe((res) => {
      this.photoalbum = res.data ;
})
  }
  insertappenddata(){
    this.photoFormdata = new FormData();
    this.photoFormdata.append("Title", this.photoForm.value.title);
    this.photoFormdata.append("TitleAr", this.photoForm.value.titleAr);
    this.photoFormdata.append("PhotoAlbumId", this.photoForm.value.photoalbumid);
    this.photoFormdata.append("PhotoImage", this.Image);
   
  }
  updateappenddata(){
    this.photoFormdata = new FormData();
    this.photoFormdata.append("Id", this.recordtoupdate.id);
    this.photoFormdata.append("Title", this.photoForm.value.title);
    this.photoFormdata.append("TitleAr", this.photoForm.value.titleAr);
    this.photoFormdata.append("PhotoAlbumId", this.photoForm.value.photoalbumid);
    this.photoFormdata.append("PhotoImage", this.Image);
   
  }
  checkEdit() {
    this._PhotoService.Data.subscribe((res) => {
      if (res != null) {
        this.photoForm = this._FormBuilder.group({
          title: [res.title],
          titleAr: [res.titleAr, Validators.required],
          photoalbumid: [res.photoAlbumId, Validators.required], 
          photoimage : [res.image]
        });
        this.imageLogo = this.img + res.image;
        // let driver = this.getById(res);
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        // this.initiate();
      }
     
    });
  }

  // imgFile
  getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
        this.photoForm.get("photoimage").setValue(this.Image);
      };
    }
  }
  get fc() {
    return this.photoForm.controls;
  }
  onSubmit(){
    this.button = true;
   if(this.update == false && this.photoForm.status == "VALID"){
    this.insertappenddata()
    this._PhotoService.Createphoto(this.photoFormdata).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.photoForm.reset();
      this._Router.navigate(['/content/admin/ViewPhoto']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
      this.button = false ;
    }, () => {
    })
   } else if(this.photoForm.status == "VALID"){
     this.updateappenddata()
    this._PhotoService.Updatephoto(this.photoFormdata).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.photoForm.reset();
      this._Router.navigate(['/content/admin/ViewPhoto']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
    }, () => {
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.photoForm.markAllAsTouched();
    this.button = false;
   }
  }
  ngOnDestroy(){
    this._PhotoService.Data.next(null);
     }
}

